import { useEffect, useState } from "react";

const LINKS = [
  { label: "WATCH", href: "#watch" },
  { label: "THE SYSTEM", href: "#system" },
  { label: "FAQ", href: "#faq" },
];

export default function ReplayNav() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 400);
    return () => clearTimeout(t);
  }, []);

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      aria-label="Primary"
      data-testid="replay-nav"
      className={`fixed left-0 right-0 top-4 md:top-6 z-[100] mx-auto flex justify-center pointer-events-none transition-all duration-700 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"
      }`}
    >
      <div
        className="flex items-center gap-1 md:gap-2 rounded-full px-2 md:px-3 py-2 pointer-events-auto max-w-[calc(100vw-24px)]"
        style={{
          background: "rgba(7,7,9,0.85)",
          border: "1px solid rgba(240,236,228,0.08)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
        }}
      >
        <a
          href="#top"
          onClick={scrollTo("#top")}
          className="px-3 md:px-4 py-2 font-mono text-[9px] md:text-[10px] tracking-[0.28em] text-[#C9A84C] whitespace-nowrap"
          data-testid="replay-nav-wordmark"
        >
          SMALL BUSINESS AUTOMATOR
        </a>
        <div className="hidden md:flex items-center gap-1">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={scrollTo(l.href)}
              className="px-3 py-2 font-mono text-[10px] tracking-[0.22em] text-[#F0ECE4]/70 hover:text-[#F0ECE4] transition-colors"
              data-testid={`replay-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </div>
        <a
          href="#book"
          onClick={scrollTo("#book")}
          className="ml-1 rounded-full bg-[#C9A84C] px-3 md:px-5 py-2 font-body text-[9px] md:text-[11px] font-bold uppercase tracking-[0.12em] md:tracking-[0.14em] text-[#070709] transition-transform hover:-translate-y-[1px] whitespace-nowrap"
          data-testid="replay-nav-cta"
        >
          Book Call ↗
        </a>
      </div>
    </nav>
  );
}
